import React, { FC, useEffect, useState } from "react";
import { API_URL } from "../../../actions/settings";
import LoadingSpinner from "../../extras/LoadingSpinner";
import CostAvoidanceOverviewTable from "./CostAvoidanceDataTables/CostAvoidanceOverviewTable";
import { IonCol, IonGrid, IonRow } from "@ionic/react";
import './CostAvoidanceData.css'
import CostAvoidanceMeterTableContainer from "./CostAvoidanceDataTables/CostAvoidanceMeterTableContainer";

async function getConsumptionData(token: string,id:string|null) {
  return fetch(`${API_URL}/cost_avoidance/data/${id}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: token,
    },
  }).then((res) => res.json())
}

interface IProps {
    building: null | string;
};

const CostAvoidanceData:FC<IProps> = (props) => {
    const [data,setData] = useState<any>(null)

    useEffect(() => {
    const handleData = async () => {
      const token = `Token ${(localStorage.getItem("token")||'').slice(1, -1)}`;
      const res = await getConsumptionData(token,props.building)
      if(res.status === 'success'){
        setData(res.data)
      }
      else{
        setData(
          {'error':'No Cost Avoidance Data Available.'}
        )
      }

    };
    handleData();
  }, [props.building]);


  if(!data){
    return <LoadingSpinner/>
  }

  if("error" in data){
    return <div>
      <h3>{data['error']}</h3>
    </div>
  }else{
    return <IonGrid style={{width:'100%'}}>
      <IonRow>
        <IonCol size="12" style={{textAlign:'center'}}>
          <h4>Cost Avoidance Breakdown Per Month</h4>
          <CostAvoidanceOverviewTable data={data.cost_avoidance} meter_columns={data.meter_columns}/>
        </IonCol>
      </IonRow>
      <ul style={{listStyle:'none'}}>
      {data.meter_data.map((e:any)=>{
        return <CostAvoidanceMeterTableContainer key={e.id} meter={e}/>
      })}
      </ul>      
    </IonGrid>
  }
};

export default CostAvoidanceData;